import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Button} from 'react-bootstrap';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import config from '../../../../../config/common.json';
import {FormattedMessage} from "react-intl";
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import ButtonAction from '../../../_common/components/ButtonAction';

const ButtonRedirect = ({data}) => {
  const {adminPermissionsLevel} = useSelector(
    (state) => ({
      adminPermissionsLevel: state.auth.adminPermissionsLevel,
    }),
    shallowEqual
  );

  const handleRedirectToPlatform = () => {
    const platformURL = process.env.NODE_ENV === 'production'
      ? window.location.hostname === 'devadmin.accuraiser.com' ? config.test_main_client_base_URL : config.main_client_base_URL
      : config.dev_main_client_base_URL;
    const adminURL = process.env.NODE_ENV === 'production'
      ? window.location.hostname === 'devadmin.accuraiser.com' ? config.client_base_URL : config.admin_base_URL
      : config.dev_main_client_base_URL;
    const url = (data?.originTypeID === 1)
      ? `${platformURL}/inspection/${data.shumaID}/1`
      : `${adminURL}/old-inspection-details/${data.shumaID}`;
    window.open(
      url,
      data?.originTypeID === 1 ? '_blank' : '_self',
      'noreferrer'
    );
  };
  const disabledCondition = !can(T.FULL, S.INSPECTIONS_PAGE) || adminPermissionsLevel !== 2;

  return (
    <ButtonAction
      iconButtonType={'success'}
      variant={'icon'}
      label={
        <img
          src={toAbsoluteUrl('media/common/Redirect_green.svg')}
          alt={'redirect'} className="w-20px h-20px"
        />
      }
      title={TTS.REDIRECT_TO_PLATFORM}
      disabled={disabledCondition}
      onClick={() => handleRedirectToPlatform()}
      customClassnames={'my-1'}
    />
  );
};

export default ButtonRedirect;